module.exports = __webpack_public_path__ + "assets/img/login-bg.753fa50a.png";